import { useSelector } from "react-redux";

import { getPortalConfigSelector, PortalConfiguration } from "../../ducks/portalConfig";

export type ConfigSettings = NonNullable<PortalConfiguration["settings"]>;

export type UseConfigSettingsResult = ConfigSettings & {
  isLoading: boolean;
};

const DEV_ENV: Partial<ConfigSettings> = {
  hideAuthorship: process.env.HIDE_AUTHORSHIP as unknown as boolean,
  signupByInvite: process.env.SIGNUP_BY_INVITE as unknown as boolean,
  authRedirectUrl: process.env.AUTH_REDIRECT_URL || undefined,
};

export const useConfigSettings = (): UseConfigSettingsResult => {
  const config = useSelector(getPortalConfigSelector);
  const settings = config?.settings || {};

  return {
    isLoading: !config,
    ...DEV_ENV,
    ...settings,
  };
};
